// test698
(698 && 0);
